import React, {Fragment} from 'react'
import {useSelector} from "react-redux";
import {GeoJSONLayer} from "react-mapbox-gl";
import {ChangeImagery} from "../components/ChangeImagery";
import {ChangesLayer} from "../components/ChangesLayer";


function ChangesContainer(props){
    const changeProps = useSelector(
        state => state.changes);
    if  (changeProps.selected===-1){return null}
    const activeChange = changeProps.layers[changeProps.selected]
    const features = changeProps.changeFeatures
    const dataUrl = activeChange.assets.ndvi.href

    return (
        <Fragment>

        <ChangeImagery activeChange={activeChange} changes={features}/>
        <ChangesLayer changes={features} dataUrl={dataUrl} selectedValue={changeProps.selectedValue}/>
        <GeoJSONLayer data={activeChange } linePaint={{'line-color':'yellow'}} />

        </Fragment>

    )
}
export default ChangesContainer




// WEBPACK FOOTER //
// ./src/containers/Changes.js